/* eslint-disable radix */
import RestService from '../services/rest';

async function getListNotify(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/Notify/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getNotificationHistoryList(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/Notify/historyList?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function createNotify(newNotify) {
  return RestService.postAuthenticated('panel/notify/create', newNotify);
}

async function updateNotify(notify) {
  return RestService.putAuthenticated('panel/notify/update', notify);
}

async function updateNotifyDisable(notify) {
  return RestService.putAuthenticated('panel/notify/updateDisable', notify);
}

async function deleteNotify(id) {
  return RestService.deleteAuthenticated('panel/notify/delete', { id });
}

export default {
  getListNotify,
  createNotify,
  updateNotify,
  updateNotifyDisable,
  deleteNotify,
  getNotificationHistoryList,
};
